import React, { useState } from "react";
import { CreateBillDto } from "../model/bill/dto/CreateBillDto";
import { UpdateBillDto } from "../model/bill/dto/UpdateBillDto";
import { PDFDocument } from "../table/PDFDocument";
import { pdf } from "@react-pdf/renderer";
import FileSaver from "file-saver";
import { Button } from "./Button";
import { useFormContext } from "react-hook-form";
import { useAppDispatch, useAppSelector } from "../redux/store";
import { billActions } from "../redux/bill/bill.slice";
import { AtiraToast } from "../utils/AtiraToast";
import { billSliceSelectors } from "../redux/bill/bill.selector";
import { Bill } from "../model/bill/types/Bill";

type SaveEmailButtonProps = {
  onClose: VoidFunction;
};

export const SaveEmailButton: React.FC<SaveEmailButtonProps> = ({
  onClose,
}) => {
  const [loading, setLoading] = useState(false);

  const { getValues } = useFormContext<CreateBillDto | UpdateBillDto>();

  const dispatch = useAppDispatch();

  const billsPageSize = useAppSelector(
    billSliceSelectors.selectBillsTablePageSize
  );
  const billsPage = useAppSelector(billSliceSelectors.selectBillsTablePage);
  const billNumber = useAppSelector(billSliceSelectors.selectCurrentBillNumber);

  const onMail = async (bill: Bill) => {
    window.open(
      `mailto:?subject=Bill%20${bill.billNumber}&body=Please%20find%20the%20attached%20bill%20below.%0A%0AThank%20you,%0ASham%20Auto%20Parts.`,
      "_blank"
    );
  };

  const onSaveEmail = async () => {
    try {
      setLoading(true);

      const dto = getValues();

      dto.soldTo = dto?.soldTo?.trim();
      dto.receivedBy = dto?.receivedBy?.trim();
      dto.billDetails?.forEach(
        (b) =>
          (b.amount = (Number(b?.qty || 0) * Number(b?.unitPrice || 0)).toFixed(
            2
          ))
      );

      const blob = await pdf(
        <PDFDocument
          dto={{
            ...dto,
            billNumber: (dto as any).billNumber || billNumber,
          }}
        />
      ).toBlob();

      if (!blob) {
        console.error("No blob found in the document");
        setLoading(false);
        return;
      }

      const bill = await dispatch(
        billActions.createBill({
          ...dto,
          invoiceDate: new Date(
            (dto as CreateBillDto).invoiceDate
          ) as unknown as string,
          billDetails: (dto as CreateBillDto).billDetails.filter(
            (bd) =>
              bd.qty?.length ||
              bd.code?.length ||
              bd.unitPrice?.length ||
              bd.description?.length
          ),
        } as CreateBillDto)
      ).unwrap();

      await dispatch(
        billActions.getLatestBills({
          meta: {
            page: billsPage - 1,
            count: billsPageSize,
          },
        })
      ).unwrap();

      FileSaver.saveAs(blob, `shamautoparts-${bill.billNumber}.pdf`);

      onClose();

      onMail(bill);
    } catch (e) {
      console.log(e);
      AtiraToast.apiError(e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button
      onClick={onSaveEmail}
      loading={loading}
      className={`btn btn-primary border-0`}
    >
      Save & Email bill
    </Button>
  );
};
